import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'contents',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: true,
  emptyMessage: "You don't have contents, visit the content section to create one.",


  newButton:false,
  getURL:'userVodSportroomContents',
  sessionParams: [],

  emptyMessage: "You don't have any graphic manifest on this manager, click on the \"+\" icon to create one.",


  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canOpen: true,
      canFilter:true,
      helpText: 'Name of the user.',
    },
    {
      attributeName: 'app',
      label: 'Sportroom name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canOpen: true,
      canFilter:false,
      helpText: 'Name of the room.',
    },
    {
      attributeName: 'config',
      label: 'Config name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canOpen: true,
      canFilter:false,
      helpText: 'Name of the config.',
    },
  ],
};
